import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { TESTIDS } from "@/constants/testIds";

const faqs = [
  {
    q: "¿Cómo se recopilan los datos?",
    a: "Obtenemos los datos desde fuentes públicas, registros oficiales y scraping legalmente permitido. Siempre cuidamos que la información esté actualizada, limpia y lista para usar — y en coherencia con la Ley 21.719.",
  },
  {
    q: "¿Los contactos cumplen con la nueva Ley 21.719?",
    a: "Sí. Trabajamos únicamente con datos de carácter empresarial (B2B) provenientes de fuentes públicas legales. Cada base incluye documentación de origen para garantizar trazabilidad.",
  },
  {
    q: "¿Cuánto cuesta el servicio?",
    a: "Los precios varían según el tamaño y la complejidad del pedido. Escríbenos por WhatsApp con lo que necesitas y te enviamos una cotización rápida y clara.",
  },
  {
    q: "¿En cuánto tiempo entregan las bases?",
    a: "Depende del tipo de solicitud. Bases estándar pueden entregarse en menos de 24 horas. Bases personalizadas pueden tardar entre 1 y 3 días hábiles.",
  },
  {
    q: "¿La información está actualizada?",
    a: "Sí. Nuestra prioridad es entregar datos útiles y actuales. Cada base de datos tiene una fecha de actualización incluida.",
  },
  {
    q: "¿En qué formato entregan las bases?",
    a: "Entregamos en el formato que necesites: Excel, CSV, SQL, Google Sheets o el que tu equipo utilice.",
  },
  {
    q: "¿Ofrecen garantía sobre los datos?",
    a: "Sí. Si encuentras correos o teléfonos desactualizados dentro de un rango razonable, los reemplazamos sin costo adicional.",
  },
  {
    q: "¿Trabajan con empresas de cualquier rubro?",
    a: "Sí. Atendemos a empresas de todos los sectores en Chile: construcción, retail, servicios profesionales, inmobiliario, salud, exportación, entre otros.",
  },
];

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      data-testid={TESTIDS.faqSection}
      className="relative py-24 lg:py-32 border-t border-[rgba(0,240,255,0.08)]"
    >
      <div className="max-w-5xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="text-center mb-14">
          <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#00f0ff] mb-4">
            / 06 — Preguntas frecuentes
          </div>
          <h2 className="font-display font-black text-white text-4xl sm:text-5xl leading-[1] tracking-tight">
            ¿Tienes una <span className="italic font-light text-[#00f0ff]">duda</span>?
            <br />
            Aquí está la respuesta.
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                data-testid={TESTIDS.faqItem(i)}
                className={`rounded-2xl border transition-all overflow-hidden ${
                  isOpen
                    ? "border-[rgba(0,240,255,0.5)] bg-[rgba(0,240,255,0.04)]"
                    : "border-[rgba(0,240,255,0.12)] bg-[rgba(10,18,36,0.4)]"
                }`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
                  data-testid={`faq-trigger-${i}`}
                >
                  <span className="font-display font-semibold text-white text-base sm:text-lg leading-tight">
                    {f.q}
                  </span>
                  <div
                    className={`w-9 h-9 rounded-full border flex items-center justify-center shrink-0 transition-all ${
                      isOpen
                        ? "bg-[#00f0ff] border-[#00f0ff] text-[#040812]"
                        : "border-[rgba(0,240,255,0.3)] text-[#00f0ff]"
                    }`}
                  >
                    {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? "max-h-96" : "max-h-0"
                  }`}
                >
                  <div className="px-6 pb-6 text-[#94a3b8] text-[14px] leading-relaxed">
                    {f.a}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
